<template>
  <ContentSection>
    <Container>
      <h2
        v-if="data.title"
        class="mb-8 ml-8 text-md font-bold md:text-xl lg:text-2xl"
      >
        {{ data.title }}
      </h2>
      <ul class="-m-2 grid grid-cols-1 md:grid-cols-3">
        <li
          v-for="(entry, index) in data.entries"
          :key="index"
          class="group flex w-full flex-col p-2"
        >
          <div
            class="flex h-full flex-col items-center bg-gray-10 px-6 py-8 transition-colors duration-300 group-hover:bg-black"
          >
            <div class="flex flex-col items-center max-lg:gap-4">
              <AppImage
                v-if="entry.image"
                :asset="entry.image"
                contain
                class="mb-1 mr-2 h-8 group-hover:invert lg:mr-0"
              />
              <p
                v-if="entry.title"
                class="text-sm font-bold uppercase tracking-wider group-hover:text-white lg:mt-5 lg:text-md"
              >
                {{ entry.title }}
              </p>
            </div>

            <p
              v-if="entry.text"
              class="mt-2 flex max-w-sm flex-1 text-center text-sm font-medium text-gray-300 group-hover:text-white lg:text-sm1"
            >
              {{ entry.text }}
            </p>

            <AppButton
              v-if="entry.link && entry.link_text"
              :to="cmsLink(entry.link)"
              class="mt-6 group-hover:bg-white group-hover:text-black"
            >
              {{ entry.link_text }}
            </AppButton>
          </div>
        </li>
      </ul>
    </Container>
  </ContentSection>
</template>

<script setup lang="ts">
import type { AssetFragment } from '#gql'

const cmsLink = useCmsLink()

defineProps<{
  data: {
    title: string
    entries: {
      title: string
      text: string
      image: AssetFragment
      link: string
      link_text: string
    }[]
  }
}>()
</script>
